import styled from "styled-components";

export const SignUpPageWrapper = styled.div`
`;